<template>
	<v-layout row wrap fill-height align-center justify-center class="py-5">
		<v-flex xs12 sm8 md7 lg6 xl4>
			<v-card>
				<v-card-text class="pa-4">
					<h2 class="display-1 mb-4 facebookh2">Informace o uživateli</h2>
					<v-form v-model="valid">
						<v-text-field
							label="Jméno a příjmení"
							v-model="customer.name"
							required
							:rules="[requiredRulle]"
							></v-text-field>

						<v-text-field
							class="input-group--dirty telephone-input-step3"
							label="Telefon"
							v-model="customer.telephone"
							required
							prefix="+420 "
							mask="### ### ###"
							:rules="[requiredRulle, v => v && v.length == 9 || 'Nesprávný formát']"
							></v-text-field>

						<v-text-field
							label="E-mail"
							v-model="customer.email"
							required
							:rules="emailRules"
							></v-text-field>

						<vuetify-google-autocomplete
							id="map"
							append-icon="search"
							:disabled="false"
							label="Město"
							placeholder=""
							ref="googleInput"
              v-on:placechanged="getAddressData"
              types="(cities)"
              country="cz"
							>
						</vuetify-google-autocomplete>

						<fb-signin-button
							:params="fbSignInParams"
							@success="onSignInSuccess"
							@error="onSignInError">
							Doplnit z Facebooku
						</fb-signin-button>

						<v-layout row wrap fill-height align-center justify-space-between>
							<v-btn
								class="ma-0"
								color="primary"
								@click="back"
								>Zpět
							</v-btn>

							<v-btn
								class="ma-0"
								:disabled="!valid"
								color="primary"
								@click="next"
								>Pokračovat
							</v-btn>
						</v-layout>
					</v-form>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import Footer from '@/components/Footer'
			import {mapGetters} from 'vuex'
			import facebookLogin from 'facebook-login-vuejs';

	export default {
		components: {
			'footer-nav': Footer,
			facebookLogin,
		},
		data() {
			return {
				customer: {
					name: '',
					email: '',
					telephone: '',
					city: '',
				},
				fbSignInParams: {
					scope: 'email, user_location, user_hometown',
					return_scopes: true
				},
				requiredRulle: v => !!v || 'Položka je povinná',
				emailRules: [
					v => !!v || 'Položka je povinná',
					v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Nesprávný formát'
				],
				valid: true,
			}
		},
		computed: {
			...mapGetters([
					'getCustomer',
			]),
		},
		methods: {
			back() {
				this.$store.commit('setActualStep', 2);
				this.$router.push('step-2');
			},
			next() {
				this.$store.dispatch('setCustomer', this.customer).then(() => {
					this.$router.push('step-4')
				})
			},
			onSignInSuccess(response) {
				FB.api('/me?fields=name,email,hometown', dude => {
					this.customer.name = dude.name;
					this.customer.email = dude.email;
					this.customer.city = dude.hometown.name;
          this.$nextTick(() => {
            this.$refs.googleInput.update(this.customer.city);
          })
				})
			},
			onSignInError(error) {
				console.log('OH NOES', error)
			},
			// getAddressData(val) {
			//   console.log(val);
			// 	this.customer.city = val;
			// },
      getAddressData: function (addressData, placeResultData, id) {

        if(addressData && addressData.locality){
          console.log(addressData.locality);
          this.customer.city = addressData.locality;
          this.$nextTick(() => {
            this.$refs.googleInput.update(addressData.locality);
          })
        }
      }
		},
		mounted() {
			this.customer = this.getCustomer;
      this.$nextTick(() => {
        this.$refs.googleInput.update(this.customer.city);
      })
		},
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Step3.vue